// import { registerMicroApps, start } from 'qiankun';
import Vue from 'vue';
import VueMoment from 'vue-moment';
import {
  ConfigProvider,
  Checkbox,
  Form,
  Input,
  Button,
  Layout,
  Dropdown,
  Menu,
  Table,
  Badge,
  Modal,
  Row,
  Col,
  Upload,
  Icon,
  Select,
  TreeSelect,
  Switch,
  InputNumber,
  Radio,
  Popconfirm,
  Drawer,
  Spin,
  message,
  Transfer,
  Divider,
  Tree,
  Tag,
  List,
  notification,
  FormModel,
  DatePicker
} from 'ant-design-vue';
import './styles/index.less';
import App from './App';
import router from './router';
import store from './store';
import * as consts from './consts';
import '@/assets/theme.light.less';
import '@/utils/globalState';

const render = () => {
  /* eslint-disable no-new */
  new Vue({
    el: '#mainapp-root',
    router,
    store,
    render: h => h(App),
  });
};

Vue.config.productionTip = false;
Vue.use(VueMoment);
Vue.use(Tree);
Vue.use(ConfigProvider);
Vue.use(Form);
Vue.use(Input);
Vue.use(Button);
Vue.use(Layout);
Vue.use(Dropdown);
Vue.use(Menu);
Vue.use(Table);
Vue.use(Badge);
Vue.use(Modal);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Icon);
Vue.use(Select);
Vue.use(Switch);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(Popconfirm);
Vue.use(TreeSelect);
Vue.use(Drawer);
Vue.use(Spin);
Vue.use(Transfer);
Vue.use(Divider);
Vue.use(Checkbox);
Vue.use(Tag);
Vue.use(List);
Vue.use(FormModel);
Vue.use(DatePicker);
Vue.prototype.$message = message;
Vue.prototype.$consts = consts;
Vue.prototype.$notification = notification;

render();

/* eslint-disable */
// 丽红超时特殊处理，浏览器版本低，增加Obejct.entries polyfill
if (!Object.entries) {
  Object.entries = function (obj) {
    let ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i);
    while (i--) { resArray[i] = [ownProps[i], obj[ownProps[i]]]; }

    return resArray;
  };
}


// const loadStyle = (url, title, enabled) => new Promise((resolve) => {
//   const head = document.getElementsByTagName('head')[0];
//   const link = document.createElement('link');
//   link.type = 'text/css';
//   link.rel = enabled ? 'stylesheet' : 'alternate stylesheet';
//   link.href = url;
//   link.title = title;
//   link.onload = () => {
//     resolve('css load succeeds');
//   };
//   setTimeout(() => {
//     // 假设1000秒css都没有加载，我们认为加载出现问题，人就resolve调，不然会挂起JS的加载
//     resolve(new Error('css load fails'));
//   }, 1000);
//   head.appendChild(link);
// });

// const loadThemeStyles = theme => Promise.race([
//   loadStyle(
//     'https://hh-oss-html.miyapay.com/box/5cd3c4c8d1622148065af604b1a50acb.css',
//     'main-light',
//     theme === THEMES.LIGHT,
//   ),
//   loadStyle(
//     'https://hh-oss-html.miyapay.com/box/320727b5b40f9055979a087be3c4a11a.css',
//     'main-dark',
//     theme === THEMES.DARK,
//   ),
// ]);

// if (process.env.NODE_ENV === 'development') {
//   // loadThemeStyles(themeSavedInStorage || THEMES.LIGHT).then(() => {
//   //   render();
//   // });

//   require('@/assets/theme.light.less'); // eslint-disable-line
//   render();
// } else {
//   loadThemeStyles(themeSavedInStorage || THEMES.LIGHT).then(() => {
//     render();
//   });
// }
